/* global CookieConsent, gtag */

document.addEventListener('DOMContentLoaded', () => {
  // if we just reloaded due to consent revoke, clear the guard so future revokes can reload again
  try {
    if (sessionStorage.getItem('cc_reload_in_progress')) {
      sessionStorage.removeItem('cc_reload_in_progress');
    }
  } catch (e) { /* ignore */ }
  try {
    CookieConsent.run({
      guiOptions: {
        consentModal: {
          layout: 'bar inline',
          position: 'bottom',
          equalWeightButtons: true,
          flipButtons: false,
        },
        preferencesModal: {
          layout: 'box',
          position: 'right',
          equalWeightButtons: true,
          flipButtons: false,
        },
      },
      // callbacks from CookieConsent library
      onFirstConsent: function () {
        try {
          var prefs = CookieConsent.getUserPreferences && CookieConsent.getUserPreferences();
          if (prefs && prefs.acceptedCategories && prefs.acceptedCategories.indexOf('analytics') !== -1) {
            enableGoogleAnalyticsConsent();
          } else if (localStorage.getItem('site_consent_analytics') === 'granted') {
            // only revoke if analytics was previously granted
            disableGoogleAnalyticsConsent();
          }
        } catch (e) {
          // ignore
        }
      },
      onConsent: function () {
        try {
          var prefs = CookieConsent.getUserPreferences && CookieConsent.getUserPreferences();
          if (prefs && prefs.acceptedCategories && prefs.acceptedCategories.indexOf('analytics') !== -1) {
            enableGoogleAnalyticsConsent();
          } else if (localStorage.getItem('site_consent_analytics') === 'granted') {
            disableGoogleAnalyticsConsent();
          }
        } catch (e) {
          // ignore
        }
      },
      onChange: function () {
        try {
          var prefs = CookieConsent.getUserPreferences && CookieConsent.getUserPreferences();
          if (prefs && prefs.acceptedCategories && prefs.acceptedCategories.indexOf('analytics') !== -1) {
            enableGoogleAnalyticsConsent();
          } else if (localStorage.getItem('site_consent_analytics') === 'granted') {
            disableGoogleAnalyticsConsent();
          }
        } catch (e) {
          // ignore
        }
      },
      categories: {
        necessary: {
          readOnly: true,
        },
        analytics: {},
      },
      language: {
        default: 'de',
        autoDetect: 'browser',
        translations: {
          de: {
            consentModal: {
              title: '',
              description:
                'Wir verwenden Cookies, um Ihnen ein optimales Einkauferlebnis bieten zu können, Anzeigen zu personalisieren & Funktionen für soziale Medien bereitzustellen. Weitere Cookies verwenden wir, um anonymisierte Statistiken anfertigen zu können. Wenn Sie auf „Alle akzeptieren“ klicken stimmen Sie der Verwendung von Cookies auf unserer Seite zu. Unter „Einstellungen verwalten“ können Sie die Privatsphäre-Einstellungen jederzeit individuell festlegen oder auch später widerrufen. Weitere Informationen zur Verwendung Ihrer Daten finden Sie in unserer <a href="/pages/privatspare_datenschutz">Datenschutzerklärung</a>.',
              acceptAllBtn: 'Alle akzeptieren',
              acceptNecessaryBtn: 'Alle ablehnen',
              showPreferencesBtn: 'Einstellungen verwalten',
              footer: '',
            },
            preferencesModal: {
              title: 'Einwilligungen',
              acceptAllBtn: 'Alle akzeptieren',
              acceptNecessaryBtn: 'Alle ablehnen',
              savePreferencesBtn: 'Einstellungen speichern',
              closeIconLabel: 'Modal schließen',
              serviceCounterLabel: 'Dienste',
              sections: [
                {
                  title: 'Verwendung von Cookies',
                  description:
                    'Wir verwenden Cookies, um Ihnen ein optimales Einkauferlebnis bieten zu können, Anzeigen zu personalisieren & Funktionen für soziale Medien bereitzustellen. Weitere Cookies verwenden wir, um anonymisierte Statistiken anfertigen zu können. Wenn Sie auf „Alle akzeptieren“ klicken stimmen Sie der Verwendung von Cookies auf unserer Seite zu. Unter „Einstellungen verwalten“ können Sie die Privatsphäre-Einstellungen jederzeit individuell festlegen oder auch später widerrufen. Weitere Informationen zur Verwendung Ihrer Daten finden Sie in unserer <a href="/pages/privatspare_datenschutz">Datenschutzerklärung</a>.',
                },
                {
                  title:
                    'Unbedingt notwendige Cookies <span class="pm__badge">Immer aktiviert</span>',
                  description: 'Technisch notwendige Cookie zum Betrieb der Website.',
                  linkedCategory: 'necessary',
                },
                {
                  title: 'Analyse-Cookies',
                  description:
                    'Marketing- und Analyse-Cookies helfen uns, unsere Website und Dienstleistungen besser auf Sie abzustimmen. Durch die Erfassung von Informationen über Ihre Interaktionen auf unserer Website ermöglichen uns diese Cookies, relevante Werbeinhalte auf Ihre Interessen zuzuschneiden und die Effektivität unserer Marketingkampagnen zu messen. Analyse-Cookies sammeln Daten darüber, wie Sie unsere Website nutzen – beispielsweise welche Seiten Sie am häufigsten besuchen und ob Sie Fehlermeldungen von Webseiten erhalten. Diese Informationen nutzen wir, um die Benutzererfahrung auf unserer Website zu verbessern und sicherzustellen, dass die Website einwandfrei funktioniert. Alle durch diese Cookies gesammelten Informationen sind aggregiert und daher anonym. Wenn Sie diese Cookies nicht zulassen, wird Ihnen weniger zielgerichtete Werbung angezeigt und wir können nicht so effektiv lernen, wie wir unsere Website für Sie verbessern können.',
                  linkedCategory: 'analytics',
                },
              ],
            },
          },
        },
      },
    });
  } catch (error) {
    console.error('cookieconsent-config.js: Error running CookieConsent:', error);
  }

  // load GTM / analytics scripts that were kept inert with type="text/plain"
  function loadBlockedScriptsForCategory(category) {
    var selector = 'script[type="text/plain"][data-category="' + category + '"]';
    document.querySelectorAll(selector).forEach(function (s) {
      if (s.dataset.ccLoaded) return;
      var newScript = document.createElement('script');

      // preserve inline or external script
      if (s.src) {
        newScript.src = s.src;
        newScript.async = s.async !== undefined ? s.async : true;
      } else {
        newScript.text = s.textContent || s.innerText;
      }

      document.head.appendChild(newScript);
      s.dataset.ccLoaded = '1';
    });
  }

  // call when user grants analytics consent
  function enableGoogleAnalyticsConsent() {
    try {
      gtag('consent', 'update', {
        ad_user_data: 'granted',
        ad_personalization: 'granted',
        ad_storage: 'granted',
        analytics_storage: 'granted',
      });
    } catch (e) {
      // gtag is a wrapper that pushes to dataLayer even if gtag.js not loaded yet
    }

    // load scripts marked as analytics (GTM etc.)
    loadBlockedScriptsForCategory('analytics');
    localStorage.setItem('site_consent_analytics', 'granted');
  }
  // call when user revokes analytics consent
  function disableGoogleAnalyticsConsent() {
    try {
      gtag('consent', 'update', {
        ad_user_data: 'denied',
        ad_personalization: 'denied',
        ad_storage: 'denied',
        analytics_storage: 'denied',
      });
    } catch (e) {
      // continue even if gtag not defined
    }

    // remove previously inserted analytics scripts
    document.querySelectorAll('script[data-cc-inserted="1"]').forEach(function (s) {
      s.remove();
    });

    // also try to remove known GTM / gtag scripts
    document.querySelectorAll('script[src*="googletagmanager.com"], script[src*="gtag/js"]').forEach(function (s) {
      s.remove();
    });

    localStorage.removeItem('site_consent_analytics');

    // reload shortly to ensure cookieconsent clears cookies if configured
    var reloadGuard;
    try { reloadGuard = sessionStorage.getItem('cc_reload_in_progress'); } catch (e) { reloadGuard = null; }

    if (!reloadGuard) {
      try { sessionStorage.setItem('cc_reload_in_progress', '1'); } catch (e) { /* ignore */ }
      setTimeout(function () {
        try { location.reload(); } catch (e) { console.warn('cookieconsent: reload failed', e); }
      }, 200);
    } else {
      // guard present, skip reload to avoid loop
    }
  }

  // wire simple click-listener fallback for Consent UI buttons
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cc], .cc-btn, button, [data-role]');
    if (!btn) return;

    var text = (btn.textContent || '').trim().toLowerCase();
    var role = (btn.getAttribute('data-role') || '').toLowerCase();

    // Accept cases (German labels)
    if (
      text === 'alle akzeptieren' ||
      text.includes('alle akzeptieren') ||
      text.includes('einstellungen speichern') ||
      btn.dataset.cc === 'acceptAll' ||
      role === 'all' ||
      role === 'save'
    ) {
      enableGoogleAnalyticsConsent();
      return;
    }

    // Deny / accept only necessary: handle "Alle ablehnen" and data-role 'necessary'
    if (
      text === 'alle ablehnen' ||
      text.includes('alle ablehnen') ||
      role === 'necessary' ||
      btn.dataset.cc === 'acceptNecessary' ||
      btn.getAttribute('data-role') === 'necessary'
    ) {
      disableGoogleAnalyticsConsent();
      return;
    }
  });

  // on page load, if consent was previously granted, load analytics
  if (localStorage.getItem('site_consent_analytics') === 'granted') {
    enableGoogleAnalyticsConsent();
  }
});
